// Different page views for the PassengerAndPayment component.
export const PassengerAndPaymentView = Object.freeze({
  DEFAULT: 'DEFAULT',
  ADD_PASSENGERS: 'ADD_PASSENGERS',
  PAYMENT_METHOD: 'PAYMENT_METHOD'
});
